import { useState } from "react";

// Renders an email address assembled at runtime from parts so plain-text
// addresses never appear in the static HTML source (spambot protection).
export default function ObfuscatedEmail({ user, domain, className = "", label, ...props }) {
  const [revealed, setRevealed] = useState(false);
  const address = `${user}\u0040${domain}`;

  const handle = (e) => {
    if (!revealed) {
      e.preventDefault();
      setRevealed(true);
      window.location.href = `mailto:${address}`;
    }
  };

  return (
    <a
      href={revealed ? `mailto:${address}` : "#"}
      onClick={handle}
      className={className}
      rel="nofollow"
      {...props}
    >
      {label || (
        <span>
          {user}
          <span aria-hidden="true"> [at] </span>
          {domain}
        </span>
      )}
    </a>
  );
}
